import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch, useAppSelector } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectListItems } from '../../../../../../redux/library/selector';
import DBNCategoryComponent from '../components/dbn-category.component';
import { selectCurrent } from '../../../../../../redux/settings/selectors';
import { deepCopy } from '../../../../../../common/services/common.service';
import { settings } from '../../../../../../redux/settings/actions';
import UploadFiles from '../../../../../../models/UploadFile';
import { selectTenantOpennetworkDomainsListItems } from '../../../../../../redux/dbn-cloud/tenant-open-network-domains/selector';
import { tenantOpenNetworkDomains } from '../../../../../../redux/dbn-cloud/tenant-open-network-domains/action';
import { tenantOpenNetworkCategories } from '../../../../../../redux/dbn-cloud/tenant-open-network-categories/action';
import { selectOpennetworkCategoryCreatedItem, selectOpennetworkCategoryUpdatedItem, selectTenantOpennetworkCategoriesListItems } from '../../../../../../redux/dbn-cloud/tenant-open-network-categories/selector';
import { selectOpennetworkCategoryQueryItems } from '../../../../../../redux/dbn-cloud/opennetwork-categories/selector';

let currentChange: any = {}

const DBNCategory = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const parmas: any = useParams()
    const { getUploadFiles } = useAppSelector(selectCurrent)

    const [categoryImageIndex, setCategoryImageIndex] = useState<any>([])
    const [mediaFiles, setMediaFiles] = useState<any>([])
    const [openFile, setOpenFile] = useState<any>([]);
    
    const libraryData = useSelector(selectListItems)
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(25);
    const listDBNDomainsData = useSelector(selectTenantOpennetworkDomainsListItems)
    const listDBNCategoriesData = useSelector(selectTenantOpennetworkCategoriesListItems)
    const queryDBNCategoryData = useSelector(selectOpennetworkCategoryQueryItems)
    const createDBNCategoryData = useSelector(selectOpennetworkCategoryCreatedItem)
    const editDBNCategoryData = useSelector(selectOpennetworkCategoryUpdatedItem)
    const [selectedDbnCategory, setSelectedDbnCategory] = useState<any>({
        Name: '',
        IsSubCategory: false,
        ParentCategoryId: 0,
        Code: '',
        OpenNetworkDomainId: 0,
    })

    const listDBNDomains = () => {
        dispatch(tenantOpenNetworkDomains.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-domains/dbn-fetch`,
            entity: 'tenantOpenNetworkDomains',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
            }
        }))
    }

    const listDBNCategories = () => {
        dispatch(tenantOpenNetworkCategories.list({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch`,
            entity: 'tenantOpenNetworkCategories',
            jsonData: {}
        }))
    }

    const queryDBNCategory = (id: Number) => {
        dispatch(tenantOpenNetworkCategories.query({
            url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories/dbn-fetch-detail`,
            entity: 'tenantOpenNetworkCategories',
            jsonData: {
                Records: [
                    {
                        Id: id
                    }
                ]
            }
        }))
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectedDbnCategory({ ...selectedDbnCategory, [field]: event })
    }

    
        
    const handleFormItemChange: any = ({ value, field, idx }: any) => {
        const items = deepCopy(mediaFiles);// deep copy of grn items
        let item = items[idx];// deep copy of item to be edited
        item = { ...item, [field]: value }// updated the particular item
        items[idx] = item;
        currentChange = { value, field, idx }
        setMediaFiles(items);
        }
        
      
    

    useEffect(() => {
        if (queryDBNCategoryData?.result?.items) {
            setSelectedDbnCategory(queryDBNCategoryData?.result?.items)
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: queryDBNCategoryData?.result?.items?.MediaMappings?.MediaFiles || mediaFiles });
            setMediaFiles(localSelectedMedia)

        }
    }, [queryDBNCategoryData])

    useEffect(() => {
        listDBNDomains();
        listDBNCategories();
        setSelectedDbnCategory({
            Name: '',
            IsSubCategory: false,
            ParentCategoryId: 0,
            Code: '',
            OpenNetworkDomainId: 0,
        })
        if (parmas?.id > 0) {
            queryDBNCategory(Number(parmas?.id))
        } else {
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)  
        }
    }, [parmas])

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        mediaFiles.splice(
                    mediaFiles.length - 1,
                    1
                  )
              
                  const localMediaFiles = _.map(mediaFiles, (item) => {
                    return {
                      ...item,
                      OwnerId: Number(parmas?.id) || 0,
                      Name: selectedDbnCategory?.Name,
                      Description: selectedDbnCategory?.Name,
                      IsApproved: true,
                    }
                  })
        if (parmas?.id > 0) {
            await dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'update' }))
            await dispatch(tenantOpenNetworkCategories.update({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        {
                            ...selectedDbnCategory,
                            Id: parmas?.id,
                            MediaMappings: { MediaFiles: localMediaFiles, Templates: selectedDbnCategory?.MediaMappings?.Templates || [] },
                        }
                    ]
                }
            }))
            back();
        } else {
            await dispatch(tenantOpenNetworkCategories.resetAction({ actionType: 'create' }))
            await dispatch(tenantOpenNetworkCategories.create({
                url: `https://catalog.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/catalog/dbn-categories`,
                entity: 'openNetworkTaxonomies',
                jsonData: {
                    Context: {},
                    Records: [
                        {
                            ...selectedDbnCategory,
                            Id: 0,
                            MediaMappings: { MediaFiles: localMediaFiles, Templates: selectedDbnCategory?.MediaMappings?.Templates || [] },
                        }
                    ]
                }
            }))
            back();
        }
    }

    const back = () => {
        navigate(-1)
    }

    useEffect(() => {
        console.log('createDBNCategoryData', createDBNCategoryData)
    }, [createDBNCategoryData]);

    useEffect(() => {
        console.log('editDBNCategoryData', editDBNCategoryData)
    }, [editDBNCategoryData]);

    useEffect(() => {
        console.log('queryDBNCategoryData', queryDBNCategoryData)
    }, [queryDBNCategoryData]);

    
        const addNewMediaFilesRow = ({ selectedMediaFilesArg }: any) => {
            const localSelectedmedia = deepCopy(selectedMediaFilesArg)
            const newsSelectedMedia = {
              Id: 0,
              FileTypeId: 0,
              OwnerTypeId: 1009,
              FileMappingURL: ''
            }
            if (localSelectedmedia.length === 0 ||
              localSelectedmedia[localSelectedmedia?.length - 1]?.FileTypeId !== 0
            ) {
              localSelectedmedia?.push(newsSelectedMedia)
            }
            return localSelectedmedia
          }
        
          const setCombinationInfo = async () => {
            let localSelectedMedia = deepCopy(mediaFiles)
            localSelectedMedia.splice(
              currentChange.idx,
              1,
              { ...localSelectedMedia[currentChange.idx] }
            );
            localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: localSelectedMedia });
            currentChange.field = 'FileTypeIdDONE'
            setMediaFiles(localSelectedMedia)
          }
        
          const changeImage = (idx: number, templateField: any, fileType: any) => {
            setCategoryImageIndex(idx)
            dispatch(settings.set({ getUploadFiles: 'open' }))
            setOpenFile({
              currentFileSrc: mediaFiles[idx][templateField],
              folder: 'Category',
              type: fileType
            })
          }
        
          
          const handleSubmit = (data: any) => {
            mediaFiles[categoryImageIndex].FileMappingURL = data
            const localSelectedMedia = addNewMediaFilesRow({ selectedMediaFilesArg: mediaFiles });
            setMediaFiles(localSelectedMedia)
          }
        
          const handleClose = () => {
            dispatch(settings.set({ getUploadFiles: 'close' }))
          }
        
          useEffect(() => {
            if (currentChange.field === 'FileTypeId') {
              setCombinationInfo()
            }
          }, [mediaFiles])
    

    return (
        <>
            {getUploadFiles == 'open' && <UploadFiles currentFilesSrc={openFile?.currentFileSrc}
                folder={openFile?.folder}
                handleClose={handleClose}
                handleFilesSubmit={handleSubmit}
                type={openFile?.type}
                ownerId={parmas?.id}
                />}
        
            {listDBNCategoriesData?.isLoading ||
                queryDBNCategoryData?.isLoading ||
                createDBNCategoryData?.isLoading ||
                editDBNCategoryData?.isLoading ? <PageLoader /> :
                <DBNCategoryComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectedDbnCategory={selectedDbnCategory}
                    domains={listDBNDomainsData?.result?.items}
                    paginationData={listDBNDomainsData?.result?.pagination}
                    categories={listDBNCategoriesData?.result?.items}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    id={parmas?.id}
                    handleFormItemChange={handleFormItemChange}
                    mediaFiles={mediaFiles}
                    changeImage={changeImage}

                />
            }
        </>
    )
}

export default DBNCategory;